/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface RemoveTimeOffRequest
 */
export interface RemoveTimeOffRequest {
  /**
   *
   * @type {string}
   * @memberof RemoveTimeOffRequest
   */
  timeOffId: string;
}

/**
 * Check if a given object implements the RemoveTimeOffRequest interface.
 */
export function instanceOfRemoveTimeOffRequest(
  value: object,
): value is RemoveTimeOffRequest {
  if (!("timeOffId" in value) || value["timeOffId"] === undefined) return false;
  return true;
}

export function RemoveTimeOffRequestFromJSON(json: any): RemoveTimeOffRequest {
  return RemoveTimeOffRequestFromJSONTyped(json, false);
}

export function RemoveTimeOffRequestFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): RemoveTimeOffRequest {
  if (json == null) {
    return json;
  }
  return {
    timeOffId: json["timeOffId"],
  };
}

export function RemoveTimeOffRequestToJSON(json: any): RemoveTimeOffRequest {
  return RemoveTimeOffRequestToJSONTyped(json, false);
}

export function RemoveTimeOffRequestToJSONTyped(
  value?: RemoveTimeOffRequest | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    timeOffId: value["timeOffId"],
  };
}
